import {
    Row,
    Col
  } from "react-bootstrap";
  import * as VhfLang from "../forms/vhf/VhfLang";

const  ConvertBoolToYesNoString=(label,valueBool,specialForMarkerketing)=>{
    
    if (typeof valueBool == "boolean") {
        if(specialForMarkerketing&&valueBool===true)return <Row><Col className="text-start">{VhfLang.UseForMarketingLabelPreviewYes}</Col></Row>;
        if(valueBool===true)return <Row><Col xs={4} className="text-start">{label}</Col>  <Col xs={8} className="text-start">Ja</Col></Row>;
    }
    
    if(specialForMarkerketing)return <Row><Col className="text-start">{VhfLang.UseForMarketingLabelPreviewNo}</Col></Row>;
    return <Row><Col xs={4} className="text-start">{label}</Col>  <Col xs={8} className="text-start">Nej</Col></Row>;
  }
  export default ConvertBoolToYesNoString;
  